

import { useState, useRef } from "react";
import DataTable from "react-data-table-component";
import { Modal, Row, Col, Button, Form } from "react-bootstrap";
import Icon from "../Icon/Icon";
import { useApiClient } from "../../ApiService/useApiClient";

const ProductRates = ({ RateData, MainCustomerID, setRefreshData, RefreshData }) => {
  const api = useApiClient();
  const [currData, setCurrData] = useState();
  const [previewModal, setPreviewModal] = useState(false);
  const [AddModal, setAddModal] = useState(false);
  const modalForm = useRef(null);
  const modalFormAdd = useRef(null);
  const [DatatoUse, setData] = useState(RateData);
  const [error, setError] = useState(null);
  const [serviceList, setserviceList] = useState(null);
  const [rateError, setRateError] = useState("");

  // Validation function for Rate field
  function validateRate(value) {
    const v = value.trim();
    if (!v) return "Rate is required";
    const regex = /^\d+(\.\d{1,2})?$/;
    if (!regex.test(v)) return "Rate must be a valid number (e.g., 60 or 60.00)";
    const num = parseFloat(v);
    if (num <= 0) return "Rate must be greater than 0";
    return "";
  }

  const tableColumns = [
    {
      name: "id",
      selector: (row) => row.id,
      sortable: false,
      hide: "lg",
      omit: true,
    },
    {
      name: "Service",
      selector: (row) => row.pro.proName,
      sortable: true,
    },
    {
      name: "Rate (£/Hour)",
      selector: (row) => "£" + row.customerHourlyRate?.toFixed(2),
      sortable: true,
    },
    {
      selector: (row) => {
        return (
          <Button
            style={{ float: "right" }}
            variant="outline-primary"
            size="sm"
            onClick={() => detailSelect(row)}
          >
            <Icon name="edit-fill" />
            &nbsp;Edit
          </Button>
        );
      },
    },
  ];

  function detailSelect(obj) {
    setRateError("");
    setCurrData(obj);
    setPreviewModal(true);
  }

  function closePreviewModal() {
    setPreviewModal(false);
  }

  function closeAddModal() {
    setAddModal(false);
  }

  function openAddModel() {
    setRateError("");
    const baseURL2 = "HMCareData/servicelist/";

    api
      .get(baseURL2)
      .then((Response) => {
        setserviceList(Response.data);
        setAddModal(true);
      })
      .catch((error) => {
        setError(error);
        console.log({ error });
      });
  }

  function handleFormSubmit(event) {
    event.preventDefault();
    const customerHourlyRate = modalForm.current.querySelector('#customerHourlyRate').value;

    const error = validateRate(customerHourlyRate);
    if (error) {
      setRateError(error);
      return;
    }

    setRateError("");

    const frmFormData = new FormData();
    frmFormData.append("ProId", currData.proId);
    frmFormData.append("CustomerId", currData.customerId);
    frmFormData.append("Id", currData.id);
    frmFormData.append("customerHourlyRate", customerHourlyRate);

    const sURL = "HMCareData/customer/modifycustomerservicerates/";

    api.post(sURL, frmFormData)
      .then((Response) => {
        updateState(Response.data);
        setRefreshData(!RefreshData);
      })
      .catch((error) => {
        setError(error);
        console.log({ error });
      });

    setPreviewModal(false);
  }

  function handleFormSubmitAdd(event) {
    event.preventDefault();
    const customerHourlyRate = modalFormAdd.current.querySelector('#customerHourlyRate').value;
    const ProID = modalFormAdd.current.querySelector('#ProID').value;

    const error = validateRate(customerHourlyRate);
    if (error) {
      setRateError(error);
      return;
    }

    setRateError("");

    const frmFormData = new FormData();
    frmFormData.append("ProId", ProID);
    frmFormData.append("CustomerId", MainCustomerID);
    frmFormData.append("customerHourlyRate", customerHourlyRate);

    const sURL = "HMCareData/customer/addcustomerservicerates/";

    api.post(sURL, frmFormData)
      .then((Response) => {
        const updatedDataObj = Response.data;
        let tempArr = [...DatatoUse];
        tempArr.push(updatedDataObj);
        setData(tempArr);
        setRefreshData(!RefreshData);
      })
      .catch((error) => {
        setError(error);
        console.log({ error });
      });

    setAddModal(false);
  }

  const updateState = (updatedData) => {
    const newState = DatatoUse.map((obj) => {
      if (obj.proId === updatedData.proId) {
        return {
          ...obj,
          customerHourlyRate: updatedData.customerHourlyRate,
        };
      }
      return obj;
    });
    setData(newState);
  };

  return (
    <>
      <Row className="mb-3">
        <Col className="d-flex justify-content-end">
          <Button variant="outline-primary" onClick={openAddModel} size="sm">
            + Add Service
          </Button>
        </Col>
      </Row>

      <DataTable
        tableClassName="data-table-head-light table-responsive"
        data={DatatoUse}
        columns={tableColumns}
        striped={true}
        highlightOnHover={true}
        filterFieldName={"Service"}
      />

      {/* Modify Modal */}
      {currData && (
        <Modal show={previewModal} onHide={closePreviewModal}>
          <Modal.Header closeButton>
            <Modal.Title className="event-title" as="h4">
              Modify Service Rates
            </Modal.Title>
          </Modal.Header>

          <Form ref={modalForm} onSubmit={handleFormSubmit}>
            <Modal.Body>
              <Row className="g-3">
                <Col xs="12">
                  <Form.Group>
                    <Form.Label>Rate (£/Hour)</Form.Label>
                    <Form.Control
                      id="customerHourlyRate"
                      type="text"
                      defaultValue={currData.customerHourlyRate}
                      placeholder="Eg, 60.00"
                      isInvalid={!!rateError}
                    />
                    <Form.Control.Feedback type="invalid">{rateError}</Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" type="submit">
                Update
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      )}

      {/* Add Modal */}
      <Modal show={AddModal} onHide={closeAddModal}>
        <Modal.Header closeButton>
          <Modal.Title className="event-title" as="h4">
            Add Service Rate
          </Modal.Title>
        </Modal.Header>

        <Form ref={modalFormAdd} onSubmit={handleFormSubmitAdd}>
          <Modal.Body>
            <Row className="g-3">
              {serviceList && (
                <Col xs="12">
                  <Form.Group>
                    <Form.Label>Service</Form.Label>
                    <Form.Select id="ProID">
                      {serviceList.map((service) => (
                        <option key={service.id} value={service.id}>
                          {service.value}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              )}
              <Col xs="4">
                <Form.Group>
                  <Form.Label>Rate (£/Hour)</Form.Label>
                  <Form.Control
                    id="customerHourlyRate"
                    type="text"
                    placeholder="Eg, 60.00"
                    isInvalid={!!rateError}
                  />
                  <Form.Control.Feedback type="invalid">{rateError}</Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" type="submit">
              Add
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default ProductRates;



// import { useState, useRef } from "react";
// import DataTable from "react-data-table-component";
// import {Modal, Row, Col,Button, Form} from 'react-bootstrap';
// import Icon from "../Icon/Icon";
// import { useApiClient } from "../../ApiService/useApiClient";

// const ProductRates = ({RateData, MainCustomerID, setRefreshData, RefreshData}) => {  

//   const api = useApiClient();
//   const [currData, setCurrData] = useState();
//   const [previewModal, setPreviewModal] = useState(false);
//   const [AddModal, setAddModal] = useState(false);
//   const modalForm = useRef(null);
//   const modalFormAdd = useRef(null);
//   const [DatatoUse, setData] = useState(RateData);
//   const [error, setError] = useState(null);
//   const [serviceList, setserviceList] = useState(null);


//   const tableColumns = [
//     {
//       name: "id",
//       selector: (row) => row.id,
//       sortable: false,
//       hide : "lg",
//       omit : true, 
  
//     },
//     {
//         name: "Service",
//         selector: (row) => row.pro.proName,
//         sortable: true,      
//       },
//     {
//       name: "Rate (£/Hour)",
//       selector: (row) => '£' + row.customerHourlyRate?.toFixed(2),
//       sortable: true,    
//     },    
//   {    
//     selector: (row) => {
//       const  value  = row.invoiceId;
//       return <><Button style={{float:"right"}} variant="outline-primary" size='sm' onClick={()=>{detailSelect(row)}}><Icon name="edit-fill"></Icon>&nbsp;Edit</Button> </>        
//     },
      
//   }, 
    
//   ];


//   function detailSelect(obj){

//     console.log(obj);
//     setCurrData(obj);
//     setPreviewModal(true)
   

//     }

//     function closePreviewModal(){
//       setPreviewModal(false);
//       } 

//       function closeAddModal(){
//         setAddModal(false);
//         }    

//       function openAddModel(){

//         //console.log(MainCustomerID);

                      
//           const baseURL2 = "HMCareData/servicelist/"  
            
//           api.get(baseURL2)        
//           .then((Response)=>{
//             setserviceList(Response.data);

//            // console.log(serviceList);
            
//             //setData(RateData);

//             setAddModal(true);
//           }).catch(error => {
//               setError(error);     
//               console.log({error})
//           });
                        
//          // }

        

          
//           }   

//       function handleFormSubmit(event){

//         event.preventDefault();
//         let customerHourlyRate = modalForm.current.querySelector('#customerHourlyRate').value;
       
       
        
//         const frmFormData = new FormData();
//         frmFormData.append("ProId", currData.proId) 
//         frmFormData.append("CustomerId", currData.customerId)                
//         frmFormData.append("Id", currData.id) 
//         frmFormData.append("customerHourlyRate", customerHourlyRate) 
        
//         const sURL = "HMCareData/customer/modifycustomerservicerates/";

//         api.post(sURL,frmFormData)
//         .then((Response)=>{

//             let updatedDataObj = Response.data;            
//             updateState(updatedDataObj)

//             setRefreshData(!RefreshData)
            
//         }).catch(error => {
//             setError(error);     
//             console.log({error})
//         });

//         setPreviewModal(false);

//     }  
    
    
//     function handleFormSubmitAdd(event){

//      // console.log(RateData)
//       //return null

//       event.preventDefault();
//       let customerHourlyRate = modalFormAdd.current.querySelector('#customerHourlyRate').value;
//       let ProID = modalFormAdd.current.querySelector('#ProID').value;
                
//       const frmFormData = new FormData();
//       frmFormData.append("ProId", ProID)       
//       frmFormData.append("CustomerId", MainCustomerID)       
//       frmFormData.append("customerHourlyRate", customerHourlyRate) 
      
//       const sURL = "HMCareData/customer/addcustomerservicerates/";
     
//       api.post(sURL,frmFormData)
//       .then((Response)=>{

//           let updatedDataObj = Response.data;           
       
//           let tempArr = [...DatatoUse];
//           tempArr.push(updatedDataObj);

//           setData(tempArr)
//           setRefreshData(!RefreshData)

//       }).catch(error => {
//           setError(error);     
//           console.log({error})
//       });

//       setAddModal(false);

//   }  


//     const updateState = (updatedData) => {

//       const newState = DatatoUse.map(obj => {
//           // 👇️ if id equals 2, update country property
//           if (obj.proId === updatedData.proId) {
//           return {...obj, 
//               //proName: updatedData.proName,
//               customerHourlyRate: updatedData.customerHourlyRate
//               //status:updatedData.status            
//           };
//           }
  
//           // 👇️ otherwise return the object as is
//           return obj;
//       });
      
//       setData(newState);
      
//       };


//   return (     
    
//     <>
    
//     <Row className="mb-3">
//       <Col className="d-flex justify-content-end">
//         <Button 
//           variant="outline-primary" 
//           onClick={openAddModel} 
//           size="sm"> + Add Service </Button>
//       </Col>
//     </Row>    
    

//     <DataTable tableClassName="data-table-head-light table-responsive" 
//       data={DatatoUse} 
//       columns={tableColumns} 
//       striped={true} 
//       highlightOnHover={true}  
//       filterFieldName={"Service"} 
//       //onRowClicked={(row,event)=>{ detailSelect(row) }}     
//       />   

// {currData && 
//       <Modal show={previewModal} onHide={closePreviewModal}>
//       <Modal.Header closeButton>
//         <Modal.Title className="event-title" as="h4">Modify Service Rates</Modal.Title>  
//       </Modal.Header>
      
//       <Form ref={modalForm} onSubmit={handleFormSubmit}>
//       <Modal.Body>
//         <div>
//           <Row className="g-3">       
//               <Col xs="12">
//                   <Form.Group>
//                       <h6 className="overline-title">Rate (£/Hour)</h6>
//                       <div className="form-control-wrap">
//                           <Form.Control id="customerHourlyRate" type="text" defaultValue={currData.customerHourlyRate} placeholder="Value" />
//                       </div>
//                   </Form.Group>
//               </Col>                    
//           </Row>
//         </div>
//       </Modal.Body>
//       <Modal.Footer>          
//           <Button variant="primary" type="submit">Update</Button>
//       </Modal.Footer>
//       </Form>
//       </Modal>}

//       <Modal show={AddModal} onHide={closeAddModal}>
//       <Modal.Header closeButton>
//         <Modal.Title className="event-title" as="h4">Modify Service Rates</Modal.Title>  
//       </Modal.Header>
      
//       <Form ref={modalFormAdd} onSubmit={handleFormSubmitAdd}>
//       <Modal.Body>
//         <div>
//           <Row className="g-3">  
//              {serviceList && 
//              <Col xs="12">
//                   <Form.Group>
//                       <Form.Label htmlFor="eventTitle">Service</Form.Label>
//                       <Form.Select id="ProID" defaultValue={modalForm.ProId}>   
//                           {serviceList.map(service =>(
//                             <option value={service.id}>{service.value}</option>  
//                           ))}                                                                                                                               
//                       </Form.Select>
//                   </Form.Group>
//               </Col>   
//               }  
//               <Col xs="4">
//                   <Form.Group>
//                       <h6 className="overline-title">Rate (£/Hour)</h6>
//                       <div className="form-control-wrap">
//                           <Form.Control id="customerHourlyRate" type="text" defaultValue={DatatoUse.customerHourlyRate} placeholder="Eg, 60.00" />
//                       </div>
//                   </Form.Group>
//               </Col>                    
//           </Row>
//         </div>
//       </Modal.Body>
//       <Modal.Footer>          
//           <Button variant="primary" type="submit">Update</Button>
//       </Modal.Footer>
//       </Form>
//       </Modal>


//       </>

//   )
// }

// export default ProductRates


